/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Olive_Glad_Bull_GulpInputs */

const en_olive_glad_bull_gulp = /** @type {(inputs: Olive_Glad_Bull_GulpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time zone`)
};

const de_olive_glad_bull_gulp = /** @type {(inputs: Olive_Glad_Bull_GulpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitzone`)
};

/**
* | output |
* | --- |
* | "Time zone" |
*
* @param {Olive_Glad_Bull_GulpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const olive_glad_bull_gulp = /** @type {((inputs?: Olive_Glad_Bull_GulpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Olive_Glad_Bull_GulpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_olive_glad_bull_gulp(inputs)
	return de_olive_glad_bull_gulp(inputs)
});